import { Link } from "react-router-dom";
import { Col, Container } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";
import { Error6 } from "../../../../../Data/Pages/Pages";

const Error503 = () => {
  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <div className="error-wrapper">
        <Container>
          <div className="svg-wrraper">
            <Error6 />
          </div>
          <Col md="8" className="offset-md-2">
            <H3>Page Not Found</H3>
            <P className="sub-content">{"The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved."}</P>
            <Link to={`${process.env.PUBLIC_URL}/dashboard/default`} className="btn btn-primary btn-lg">
              {"BACK TO HOME PAGE"}
            </Link>
          </Col>
        </Container>
      </div>
    </div>
  );
};

export default Error503;
